import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ConsumerType, PendingStatus, ResidencyStatus } from "../../model/energy-profile";
import { Utility } from "../../model/energy-profile";

interface CustomerEnergyProfileState {
	// Flutter: CustomerEnergyProfileResponse fields
	id: string;
	isDeleted: boolean;
	userId: string;
	consumerType: ConsumerType;
	meterNumber: string;
	accountNumber: string;
	utilityId: string;
	utility: Utility | null;
	createdAt: string;
	updatedAt: string;
	pendingStatus: PendingStatus | null;
	preferRemoteTokenLoad: boolean | null;
	isNinVerified: boolean;
	isNinPhoneNumberVerified: boolean;
	residencyStatus: ResidencyStatus | null;
	nin: string | null;

	// Web-specific convenience fields
	meterAddress: string;
}

const initialState: CustomerEnergyProfileState = {
	id: "",
	isDeleted: false,
	userId: "",
	consumerType: ConsumerType.Unknown,
	meterNumber: "",
	accountNumber: "",
	utilityId: "",
	utility: null,
	createdAt: "",
	updatedAt: "",
	pendingStatus: null,
	preferRemoteTokenLoad: null,
	isNinVerified: false,
	isNinPhoneNumberVerified: false,
	residencyStatus: null,
	nin: null,
	meterAddress: "",
};

export const customerEnergyProfileSlice = createSlice({
	name: "customerEnergyProfile",
	initialState,
	reducers: {
		setEnergyProfileInfo: (state, action: PayloadAction<Partial<CustomerEnergyProfileState>>) => {
			Object.assign(state, action.payload);
		},

		clearEnergyProfileInfo: () => initialState,
	},
});

export const {
	setEnergyProfileInfo,
	clearEnergyProfileInfo,
} = customerEnergyProfileSlice.actions;

export default customerEnergyProfileSlice.reducer;
